module.exports = __webpack_public_path__ + "img/Rectangle 1189.0c66ff56.png";